export enum Azione
{
    ACCETTA = "ACCETTA",
    FORZA_ACCETTAZIONE_DA_PARTE_DI_BC = "FORZA_ACCETTAZIONE_DA_PARTE_DI_BC",
    RICHIEDI_VARIAZIONE = "RICHIEDI_VARIAZIONE",
    CONSEGNA_A_FORNITORE = "CONSEGNA_A_FORNITORE",
    FORZA_CONSEGNA_A_FORNITORE_DA_PARTE_DI_BC = "FORZA_CONSEGNA_A_FORNITORE_DA_PARTE_DI_BC",
    REGISTRA_CONSEGNA_A_FORNITORE = "REGISTRA_CONSEGNA_A_FORNITORE",
    INIZIA_LAVORAZIONE = "INIZIA_LAVORAZIONE",
    AGGIORNA_LAVORAZIONE = "AGGIORNA_LAVORAZIONE",
    COMPLETA_LAVORAZIONE = "COMPLETA_LAVORAZIONE",
    RICONSEGNA_A_BC = "RICONSEGNA_A_BC",
    REGISTRA_RIENTRO = "REGISTRA_RIENTRO"
}